module.exports = __webpack_public_path__ + "static/media/logo-abenepi.3ab41798.png";